import { render, staticRenderFns } from "./EmployeeWorkforceBoard.vue?vue&type=template&id=ed8aa886&scoped=true&"
import script from "./EmployeeWorkforceBoard.vue?vue&type=script&lang=js&"
export * from "./EmployeeWorkforceBoard.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeWorkforceBoard.vue?vue&type=style&index=0&id=ed8aa886&scoped=true&lang=css&"
import style1 from "./EmployeeWorkforceBoard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8aa886",
  null
  
)

export default component.exports